export const submitForm = ({
    method,
    url,
    data,
}) => {
    const form = document.createElement('form');
    form.method = method;
    form.action = url;

    Object.keys(data).forEach(key => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = key;
        input.value = JSON.stringify(data[key]);
        form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
};

const throwError = err => {
    throw new Error(err);
};

export const parseResponse = (response) =>
    response.ok ? response.json() : throwError(response.status);

export const HTTPMethod = {
    Post: 'POST',
    Get: 'GET',
    Put: 'PUT',
    Patch: 'PATCH',
    Delete: 'DELETE',
};
